// src/helpers/iban.js

//Cas utilisateur	+ Code retourné
// Champ vide + required=true	              →   (géré par composant)	    mandate.iban_required → "IBAN requis"
// Champ vide + required=false	            →   (ok)	                    pas d’erreur
// Caractères spéciaux (@, -, €, …)	        →   invalid_chars	            "L’IBAN ne doit contenir que des lettres et des chiffres"
// Moins de 4 caractères (F, FR, FR7)	      →   too_short	                "IBAN trop court"
// Code pays non géré (VN…, US…, AA…)	      →   country_not_supported	    "Code pays IBAN inconnu ou non autorisé (US)
// Pays OK mais longueur incorrecte
//    pour ce pays (FR 26 /28)	            →   wrong_length	            "Longueur IBAN incorrecte pour le pays FR"
// Tout semble bon,
//    mais IBAN modifié (clé incohérente)   →	  checksum	                "Clé IBAN invalide"


// Longueur IBAN par pays (Europe)
const IBAN_LENGTHS = {
  AT: 20,
  BE: 16,
  BG: 22,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  EE: 20,
  FI: 18,
  FR: 27,
  DE: 22,
  GR: 27,
  HU: 28,
  IE: 22,
  IT: 27,
  LV: 21,
  LT: 20,
  LU: 20,
  MT: 31,
  NL: 18,
  PL: 28,
  PT: 25,
  RO: 24,
  SK: 24,
  SI: 19,
  ES: 24,
  SE: 24
}

export function normalizeIban (input) {
  return (input || '').replace(/\s+/g, '').toUpperCase()
}

export function getIbanCountry (iban) {
  const norm = normalizeIban(iban)
  if (norm.length < 2) return ''
  return norm.slice(0, 2)
}

export function isIbanLengthValid (iban) {
  const norm = normalizeIban(iban)
  const country = getIbanCountry(norm)
  const expected = IBAN_LENGTHS[country]
  if (!expected) return false  // pays non géré
  return norm.length === expected
}

// conversion lettres → chiffres (A=10, ..., Z=35)
function charToDigits (ch) {
  const code = ch.charCodeAt(0)
  if (code >= 48 && code <= 57) { // 0-9
    return ch
  }
  if (code >= 65 && code <= 90) { // A-Z
    return String(code - 55)
  }
  return ''
}

// contrôle mod97 standard IBAN
export function isIbanChecksumValid (iban) {
  const norm = normalizeIban(iban)
  if (norm.length < 4) return false

  // on met les 4 premiers caractères à la fin
  const rearranged = norm.slice(4) + norm.slice(0, 4)

  // on remplace lettres par chiffres
  let numeric = ''
  for (let i = 0; i < rearranged.length; i++) {
    const part = charToDigits(rearranged[i])
    if (!part) return false
    numeric += part
  }

  // calcul mod97 par blocs (pour éviter les gros entiers)
  let remainder = 0
  for (let i = 0; i < numeric.length; i += 7) {
    const block = String(remainder) + numeric.substr(i, 7)
    remainder = parseInt(block, 10) % 97
  }

  return remainder === 1
}

// validation complète + message d’erreur
export function validateIban (iban) {
  const norm = normalizeIban(iban)

  if (!norm) {
    return {
      valid: false,
      code: 'empty'
    }
  }

  if (!/^[A-Z0-9]+$/.test(norm)) {
    return {
      valid: false,
      code: 'invalid_chars'
    }
  }

  if (norm.length < 4) {
    return {
      valid: false,
      code: 'too_short'
    }
  }

  const country = getIbanCountry(norm)
  if (!IBAN_LENGTHS[country]) {
    return {
      valid: false,
      code: 'country_not_supported',
      country
    }
  }

  if (!isIbanLengthValid(norm)) {
    return {
      valid: false,
      code: 'wrong_length',
      country
    }
  }

  if (!isIbanChecksumValid(norm)) {
    return {
      valid: false,
      code: 'checksum'
    }
  }

  return {
    valid: true,
    code: 'ok',
    message: ''
  }
}
